/**
 * Copyright (C) 2023 Viasat, Inc.
 * All rights reserved.
 * The information in this software is subject to change without notice and should not be construed as a commitment by Viasat, Inc.
 *
 * Viasat Proprietary
 * The Proprietary Information provided herein is proprietary to Viasat and
 * must be protected from further distribution and use. Disclosure to others,
 * use or copying without express written authorization of Viasat, is strictly prohibited.
 */
import React from 'react';
import motif from '../../static/images/insights-gmb-login-bk.svg';
import AuthForm from './AuthForm';
import AuthGridWrapper from './AuthGridWrapper';
import { ContainerStateProps, ContainerDispatchProps } from './types';
import { RouteComponentProps } from 'react-router';
import { isMockMode } from '../../utils/GlobalUtils';
import OktaForm from './OktaForm';

/**
 * AuthContainer displays one of two forms depending on how Insights is ran. When developing
 * locally in the mock server mode, it'll display a fake login form. When developing without
 * the mock server, or when Insights is running normally, it'll display the Okta sign in widget.
 */
const AuthContainer: React.FC<ContainerStateProps & ContainerDispatchProps & RouteComponentProps> = () => {
  return (
    <AuthGridWrapper className="auth">
      <div className="auth__bg" />
      {isMockMode() ? (
        <AuthForm/>
      ) : (
        <OktaForm/>
      )}
      <div className="auth__motif__container">
        <img className="auth__motif" alt="Branding motif" src={motif} />
      </div>
    </AuthGridWrapper>
  );
};

export default AuthContainer;
